export default __webpack_public_path__ + "static/media/communicate.23ce5386.JPG";